'use strict';

function CompanyProjectService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/projects/:projectId', {}, {
    'update':  {
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyProjectService', ['$resource', 'config', CompanyProjectService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/projects/CompanyProjectService.js
// module id = 370
// module chunks = 0